import React, { useEffect, useState } from 'react'
import AdminHeader from '../AdminHeader'
import './AdminMasters.css'
import { Button, Col, Container, Form, Modal, Row, Table } from 'react-bootstrap'
import { CustomerAdd, CustomerDelete, CustomerFindAll, CustomerUpdate } from '../../API/Api'
import axios from 'axios'
import { toast } from 'react-toastify'


const CustomerMaster = () => {

  const [show, setShow] = useState(false);
  const [customerName, setCustomerName] = useState();
  const [phone, setPhone] = useState();
  const [address, setAddress] = useState();
  const [data, setData] = useState([]);
  const [isEditing, setisEditing] = useState(false);
  const [customerId, setCustomerId] = useState();

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const [showEdit, setShowEdit] = useState(false);

  const userdata = JSON.parse(sessionStorage.getItem('userdata'));
  const branchId = userdata.branch_id;

  // =========== delete modal =========
 const [show1, setShow1] = useState(false);
 const handleClose1 = () => setShow1(false);

 const [itemToDelete, setItemToDelete] = useState(null);

 const handleShow1 = (item) => {
   setItemToDelete(item);
   setShow1(true);
 };  

//  =========== Edit ======
  const handleEditClose = () => {
    setShowEdit(false);
    setCustomerId('');
    setCustomerName('');
    setPhone('');
    setAddress('');
  };

  const handleEditShow = (item) => {
    setCustomerId(item.customer_id);
    setCustomerName(item.customer_name);
    setPhone(item.mobileno);
    setAddress(item.address);
    setShowEdit(true);
  };

  const updateCustomer = () => {

    if (!customerName || !phone || !address) {
      alert("All fields are required");
      return;
   }
   
    const formData = {
      customer_name : customerName ,
      mobileno : phone,
      address : address
    };
    console.log("response",formData);
    axios
      .put(`${CustomerUpdate}${customerId}`, formData)
      .then((res) => {
        if (res.data === "UPDATE") {
          
          toast.success("Data Updated Successfully!", {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
          });
          Getdata();
          handleEditClose();
        }
      })
      .catch((err) => {
        // Add debugging information to identify the issue
        console.error("Error while updating Customer:", err);
        if (err.response) {
          console.error("Response data:", err.response.data);
        }
  
        toast.error("Failed to update data, please try again", {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
      });
  };


const savedata = (e) => {
    e.preventDefault();
  
    if (!customerName || !phone || !address) {
      alert("All fields are required");
      return;
   }
  
    const obj ={
      customer_name : customerName,
      mobileno : phone,
      address : address,
      branch_id: branchId
    }
    console.log("FormData",obj)
  
    axios
      .post(CustomerAdd, obj)
      .then((res) => {
        
        if (res.data === "SAVED") {
          console.log("res.data",res.data)
          toast.success("Data Saved Successfully!", {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
          });
          // Reset form fields and reload the data
          Getdata();
          setCustomerName('');
          setCustomerId('');
          setPhone('');
          setAddress('');
          setShow(false);
          // window.location.reload(); // Note: Reloading the entire page may not be the best practice, consider updating the data from the API.
        }
      })
      .catch((err) => {
        toast.error("Failed to upload, please try again", {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
        console.error(err);
      });
  };

     //Getdata Logic
     const Getdata = (e) => {
      console.log("api...",`${CustomerFindAll}/${branchId}`);
      axios  
        .get(`${CustomerFindAll}/${branchId}`)
        .then((res) => {
          console.log("findallllllllll",res.data)
          if (res.data !== null) {
            setData(res.data);
          }
          setisEditing(false);
        })
        .catch((err) => {
          // alert("Failed to upload, try again");
          toast.error("Failed to upload, try again", {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
          });
          console.log(err);
        });
    };
  
  useEffect(() => {
    Getdata();
  }, [])
  
  
  
  
    //delete data
    const onDelete = (item) => {
      console.log("Deleting item:", item);
      axios  
        .delete(`${CustomerDelete}${item.customer_id}`)
        .then((res) => {
          console.log("Delete response:", res.data);
          if (res.data === "DELETE") {
            // alert("File Deleted Succesfully");
            toast.success("Data Deleted Succesfuly!", {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
            });
          }
          handleClose1(false)
          Getdata();
        })
        .catch((err) => {
          // alert("Failed to upload, try again");
          console.log("Error deleting item:", err);
          toast.error("Failed to upload, try again", {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
          });
          console.log(err);
        });
    };
  
        //HEADING FONT ===================

        const headingStyle = {
          fontSize: '27px',
          fontWeight: 'bold',
          textAlign: 'center',
        };
      
        const subheadingStyle = {
          color: 'rgb(255, 93, 0)', // Assuming this is the color for "text-violet-800"
          fontWeight: 300, // Assuming this is the font weight for "font-[300]"
          textShadow:"3px 1px 5px rgb(180, 180, 180)"
        };
  
  return (
    <Container fluid>
  
        <Row className='m-0'> <AdminHeader /> </Row>
   <Row  className='BgImg px-md-5'>

   {/* ====================== table =============== */}
   <Row className='m-0 p-0  px-md-5  py-1 mb-5  w-100' style={{display:"flex"}}>

   <Row className='pt-3'>
    {/* <Col style={{color:"white",display:"flex",justifyContent:"center",marginTop:"-23px"}}>
    <h4>Customer Master</h4>
    </Col> */}
    <div className="heading text-black pt-3 pt-2 pt-md-3 mt-2 mt-md-1 mb-2" style={headingStyle}>
           <span style={subheadingStyle}>Customer</span> Master
           </div>
   </Row>
   <div  style={{display:"flex"}}>
    <button className='p-1 px-2' onClick={handleShow}  style={{backgroundColor:"papayawhip",border:"2px solid darkslategray",borderTopRightRadius:"15px"}}><b >ADD</b></button>
   </div>

   <div style={{ overflowY: 'auto'}}>
  <div style={{ overflowX: 'auto' }}>
     <Table striped bordered hover size="sm" className='shadow mb-5 mt-2' style={{textAlign:"center"}}>
         <thead >
             <tr > 
                 <th style={{alignItems:"center", backgroundColor:"darkslategray",fontSize:"13px",fontFamily:"sans-serif"}} className='text-center text-light'>Sr.No</th>
                 <th style={{alignItems:"center", backgroundColor:"darkslategray",fontSize:"13px",fontFamily:"sans-serif"}} className='text-center text-light'>Customer Name</th>
                 <th style={{alignItems:"center", backgroundColor:"darkslategray",fontSize:"13px",fontFamily:"sans-serif"}} className='text-center text-light'>Mobile No</th>
                 <th style={{alignItems:"center", backgroundColor:"darkslategray",fontSize:"13px",fontFamily:"sans-serif"}} className='text-center text-light'>Address</th>
                 <th style={{alignItems:"center", backgroundColor:"darkslategray",fontSize:"13px",fontFamily:"sans-serif"}} className='text-center text-light'>Edit</th>
                 <th style={{alignItems:"center", backgroundColor:"darkslategray",fontSize:"13px",fontFamily:"sans-serif"}} className='text-center text-light'>Delete</th>
             </tr>
         </thead>
         <tbody>
           {data.map((item,index)=>{
             return(               
             <tr className='border' style={{fontSize:"14px"}}>
                 <td style={{ textAlign:"center"}}>{index+1}</td>
                 <td style={{ textAlign:"center"}}>{item.customer_name}</td>
                 <td style={{ textAlign:"center"}}>{item.mobileno}</td>
                 <td style={{ textAlign:"center"}}>{item.address}</td>
                 <td style={{textAlign:"center"}}>
                <button className=' m-1' style={{color:"rgb(255, 93, 0)",border:"0px", backgroundColor:"transparent"}}
                  onClick={() => handleEditShow(item)}
                ><i class="fa-solid fa-pen-to-square"></i></button></td>
                <td style={{textAlign:"center"}}>
                <button className=' m-1' style={{color:"red",border:"0px", backgroundColor:"transparent"}}
                
                onClick={() => handleShow1(item)}
                 ><i className="fa-solid fa-trash"></i></button></td>
             </tr>
              )
             })} 
         </tbody>
     </Table>
     </div>
     </div>
   </Row>
   {/* ========================== Modal ============= */}
   <Modal className='shadow rounded' show={show} onHide={handleClose}>
    <Modal.Header className='m-0 p-0 ps-3 text-center' style={{backgroundColor:"rgb(214, 234, 248)",color:"black"}} >
      <Modal.Title >
 
  <p style={{fontSize:"18px"}} className='text-center mt-2'><b>Customer Master</b></p>
   
   
  </Modal.Title>
</Modal.Header>
<Modal.Body>
<Form encType="multipart/form-data">
<Row className='m-0'>
   <Col sm={12} md={12} className='mt-3'>
   <Form.Label><h6 >Customer Name :</h6></Form.Label>
       <Form.Control
         aria-label="Default select example"
         onChange={(e)=>setCustomerName(e.target.value)}
         value={customerName}
         maxLength={40}
         required
       >
       </Form.Control>
     </Col>

     <Col sm={12} md={12} className='mt-3'>
      <Form.Label><h6 >Mobile No :</h6></Form.Label>
       <Form.Control
          maxLength="10"
          inputMode="numeric"  
          title='Please enter 10 digit num.'
          type="tel"
          id="mobileNumber"
          value={phone}
          onChange={(e) => {
            const numericValue = e.target.value.replace(/\D/g, "");
            setPhone(numericValue);
          }}
          required
       >
       </Form.Control>
     </Col>
     
     <Col sm={12} md={12} className='mt-3 mb-3'>
      <Form.Label><h6 >Address :</h6></Form.Label>
       <Form.Control
         aria-label="Default select example"
         onChange={(e)=>setAddress(e.target.value)}
         value={address}
         maxLength={200}
         required
       >
       </Form.Control>
     </Col>

   </Row>
  </Form>
</Modal.Body>
<Modal.Footer className='m-0 p-0' style={{backgroundColor:"rgb(214, 234, 248)"}}>
  <Button style={{color:"black",backgroundColor:"white",border:"2px solid darkslategray",borderRadius:"8"}} onClick={handleClose}>
    Cancel
  </Button>

  {
        isEditing===false ? 
          <Button style={{border:"1px solid darkslategray",backgroundColor:"darkslategray" ,borderRadius:"15px"}} className='py-2 px-3 mx-2  shadow text-light' type='submit' onClick={savedata}>
            Save 
          </Button>
          :
          <Button style={{border:"1px solid darkslategray",backgroundColor:"darkslategray" ,borderRadius:"15px"}} className='py-2 px-3 mx-2  shadow text-light' type='submit' onClick={handleClose}>
            Update
          </Button>
      }

</Modal.Footer>
</Modal>


{/* =================== Edit Modal ======================== */}
 
  <Modal show={showEdit} onHide={handleEditClose}>
      <Modal.Header className='m-0 p-0 ps-3 text-center' style={{backgroundColor:"rgb(214, 234, 248)",color:"black"}} >
      <Modal.Title >
      <p style={{fontSize:"18px"}} className='text-center mt-2'><b>Customer Master</b></p>
      </Modal.Title>
    </Modal.Header>

 <Modal.Body>
   <Form encType="multipart/form-data">
   <Row className='m-0'>
   <Col sm={12} md={12} className='mt-3'>
   <Form.Label><h6 >Customer Name :</h6></Form.Label>
       <Form.Control
         aria-label="Default select example"
         onChange={(e)=>setCustomerName(e.target.value)}
         value={customerName}
         required
         maxLength={40}
       >
       </Form.Control>
     </Col>

     <Col sm={12} md={12} className='mt-3'>
      <Form.Label><h6 >Mobile No :</h6></Form.Label>
       <Form.Control
          maxLength="10"
          inputMode="numeric"  
          title='Please enter 10 digit num.'
          type="tel"
          id="mobileNumber"
          value={phone}
          onChange={(e) => {
            const numericValue = e.target.value.replace(/\D/g, "");
            setPhone(numericValue);
          }}
          required
       >
       </Form.Control>
     </Col>
     
     <Col sm={12} md={12} className='mt-3 mb-3'>
      <Form.Label><h6 >Address :</h6></Form.Label>
       <Form.Control
         aria-label="Default select example"
         onChange={(e)=>setAddress(e.target.value)}
         value={address}
         required
         maxLength={200}
       >
       </Form.Control>
     </Col>

   </Row>
  </Form>
</Modal.Body>

    <Modal.Footer className='m-0 p-0' style={{backgroundColor:"rgb(214, 234, 248)"}}>
      <Button style={{color:"black",backgroundColor:"white",border:"2px solid darkslategray",borderRadius:"15px"}} onClick={handleEditClose}>
        Cancel
      </Button>

          <Button style={{border:"1px solid darkslategray",backgroundColor:"darkslategray" ,borderRadius:"15px"}} className='py-2 px-3 mx-2  shadow text-light' onClick={() => updateCustomer(customerId,customerName,phone,address)}>
            Update
          </Button>
        </Modal.Footer>
      </Modal>


      {/* ============= Delete Modal ========= */}

      <Modal show={show1} onHide={handleClose1}>
        <Modal.Header style={{backgroundColor:"rgb(214, 234, 248)",color:"black"}} >
          <Modal.Title><i className="fa-solid fa-trash" style={{ color: "rgb(254, 105, 129)" }}></i>  Delete Confirmation</Modal.Title>
        </Modal.Header>
        <Modal.Body >Are you sure you want to delete this item?</Modal.Body>
          <p className='text-end'>
          <Button className='mx-2' style={{color:"black",backgroundColor:"white",border:"2px solid darkslategray",borderRadius:"15px"}}  onClick={handleClose1}>
            Cancel
          </Button>
          <Button  style={{border:"1px solid darkslategray",backgroundColor:"darkslategray" ,borderRadius:"15px"}} className='py-2 px-3 mx-2  shadow text-light' onClick={() => onDelete(itemToDelete)}>
            Delete
          </Button></p>
      </Modal>

</Row>
    </Container>
  )
}

export default CustomerMaster







